export default "__VITE_ASSET__DVrfLnQh__"